import { FC } from 'react'

import adminPortalRoutes from '~/app/providers/router/adminPortalRoutes'
import marketingRoutes from '~/app/providers/router/marketingRoutes'

/**
 * Utility function to combine components
 * @param initialComponent First component that other components will be wrapped around
 * @param components List of components to wrap around the initial component
 * @returns component tree
 */
export const combineComponents = (
  initialComponent: FC,
  components: ((Component: FC) => () => JSX.Element)[],
): FC => {
  return components.reduce((accumulator, currentComponent) => {
    return currentComponent(accumulator)
  }, initialComponent)
}

export default combineComponents

export const marketingRoutePaths = marketingRoutes.map((route) => route.path)
export const adminPortalRoutePaths = adminPortalRoutes.map(
  (route) => route.path,
)
